import * as constants from '../constants/actions';

const initialState = {
	attributes: null,
	filters: {},
};

export default function reducer(state = initialState, action) {
	switch (action.type) {
		case constants.DDNY_ATTRIBUTES:
			return ddnySetAttributes(state, action);
		case constants.DDNY_FILTERS:
			return ddnySetFilters(state, action);
		default:
			return state;
	}
}

function ddnySetAttributes(state, action) {
	return Object.assign({}, state, {
		attributes: action.attributes
	});
}

function ddnySetFilters(state, action) {
	return Object.assign({}, state, {
		filters: action.filters
	});
}
